import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-dark text-light pt-5 pb-3">
    <div className="container">
      <div className="row g-4 mb-4">
        <div className="col-12 col-md-4">
          <h5 className="text-white fw-bold">EGB Systems & Solutions, Inc.</h5>
          <p style={{ fontSize: 14, color: '#94a3b8' }}>
            Transforming e-business with strategic solutions since 1999. ISO certified, GSA contract holder, INC 500 ranked.
          </p>
        </div>
        <div className="col-6 col-md-2">
          <h6 className="text-white fw-bold mb-3">Services</h6>
          {[
            { label: 'Web Services', to: '/web-services' },
            { label: 'Software Dev', to: '/services' },
            { label: 'SEO & Marketing', to: '/services' },
            { label: 'Back Office', to: '/services' },
            { label: 'AI Services ✨', to: '/ai-services' },
          ].map(link => (
            <Link key={link.label} to={link.to} className="d-block text-secondary text-decoration-none mb-1" style={{ fontSize: 13 }}>{link.label}</Link>
          ))}
        </div>
        <div className="col-6 col-md-2">
          <h6 className="text-white fw-bold mb-3">Company</h6>
          {[
            { label: 'Overview', to: '/company/overview' },
            { label: 'Why EGB', to: '/company/why-egb' },
            { label: 'Awards', to: '/company/awards' },
            { label: 'Privacy Policy', to: '/privacy-policy' },
          ].map(link => (
            <Link key={link.label} to={link.to} className="d-block text-secondary text-decoration-none mb-1" style={{ fontSize: 13 }}>{link.label}</Link>
          ))}
        </div>
        <div className="col-6 col-md-2">
          <h6 className="text-white fw-bold mb-3">Products</h6>
          <Link to="/products/epadasalai" className="d-block text-secondary text-decoration-none mb-1" style={{ fontSize: 13 }}>e-Padasalai</Link>
          <Link to="/products/thekallos360" className="d-block text-secondary text-decoration-none mb-1" style={{ fontSize: 13 }}>TheKallos360</Link>
        </div>
        <div className="col-12 col-md-4">
          <h6 className="text-white fw-bold mb-3">Contact</h6>
          <p style={{ fontSize: 13, color: '#94a3b8' }}><strong>United States</strong><br />1010 Summer Street, Suite 102<br />Stamford, Connecticut – 06905<br />Tel: 203 653 2741</p>
          <p style={{ fontSize: 13, color: '#94a3b8' }}><strong>India</strong><br />135/1, L-Block 17th Street<br />Anna Nagar, Chennai – 600102<br />Tel: +91 044-35510504</p>
          <p style={{ fontSize: 13, color: '#94a3b8' }}>support@egbsystems.com</p>
        </div>
      </div>
      <div className="border-top border-secondary pt-3 d-flex flex-column flex-md-row justify-content-between align-items-center" style={{ fontSize: 13 }}>
        <span className="text-secondary">© {new Date().getFullYear()} EGB Systems & Solutions, Inc. All rights reserved.</span>
        <div className="d-flex gap-3 mt-2 mt-md-0">
          {[
            { label: 'Privacy Policy', to: '/privacy-policy' },
            { label: 'Terms of Use', to: '/terms-of-use' },
            { label: 'Sitemap', to: '/sitemap' },
          ].map(link => (
            <Link key={link.label} to={link.to} className="text-secondary text-decoration-none">{link.label}</Link>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
